import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import useExtensionInstalled from 'Components/Hooks/useExtensionInstalled';

import 'Components/Assistant/AssistantBanner.scss';


const AssistantBanner = ({ lightTheme }) => {
  const { extensionInstalled } = useExtensionInstalled();

  if (extensionInstalled) return false;
  return (
    <div className={classNames('assistant-banner', { 'banner-light-theme': lightTheme })}>
      <div className="header-text">
        <FormattedMessage id="assistant.banner.fanaticalassistant" defaultMessage="Fanatical PC Game Price Comparison" />
        <span className="header-span"><FormattedMessage id="assistant.banner.browserextension" defaultMessage="Browser Extension" /></span>
      </div>
      <div className="banner-content">
        <div className="subtext">
          <FormattedMessage id="assistant.banner.body" defaultMessage="Save time and money when you&apos;re shopping online for games. What could be better?" />
        </div>
        <Link to={'/browser-extension'} className="assistant-banner-button btn-block">
          <FormattedMessage id="assistant.banner.button.findoutmore" defaultMessage="Find out more" />
        </Link>
      </div>
    </div>
  );
};

AssistantBanner.propTypes = {
  lightTheme: PropTypes.bool,
};

AssistantBanner.defaultProps = {
  lightTheme: false,
};

export default AssistantBanner;
